export default "__VITE_ASSET__5b163913__"